import React, { useState, useContext, useEffect } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { Redirect, useLocation } from "react-router-dom";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import RTAlertes from "components/RTAlertes/Alerts/RTAlertes";
import RTAlertRules from "components/RTAlertes/AlertRules/RTAlertRules";
import RTEvents from "components/RTAlertes/Events/RTEvents";
import RTSystemAlerts from "components/RTAlertes/SystemAlerts/RTSystemAlerts";
import AlertsTab from "components/RTAlertes/AlertsTab";
import ErrorFallbackDialog from "components/ErrorFallback/ErrorFallbackDialog";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import {
  Navigate
} from "react-router-dom";
import postPageVisit from "services/LogService";

export default function Alertes() {
  const [redirState, setRedirState] = useState(false);
  const appContext = useContext(AdvancedSearchContext);
  const { setPage } = appContext;
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const [selectedTab, setSelectedTab] = useState('');
  const permis = JSON.parse(localStorage.getItem('permission')) || [];
  const currentusertype = localStorage.getItem('userType');
  const options = JSON.parse(localStorage.getItem('memoptions')) || [];

  useEffect(() => {
    let selected = '0';
    if (currentusertype == 1 && params && params.get("tab") === 'systemalerts') {
      selected = '3';
    }
    else if (params && params.get("tab") === 'events') {
      selected = '2';
    }
    else if (params && params.get("tab") === 'alertsadmin') {
      selected = '1';
    }
    else
    {
      if (currentusertype == 1)
        selected = '3';
      else
        selected = '0';
    }
      

    if (currentusertype != 1 && !(options && options.find((x) => x.id === 'alertes') && permis && permis.includes('alerts_access')))
      selected = '2';
    else if (currentusertype != 1 && !(options && options.find((x) => x.id === 'events') && permis && permis.includes('events_access')))
      selected = '0';

    setSelectedTab(selected);
    setPage('alerts');
    postPageVisit('alerts');
  }, []);
  let redirecting = redirState && (
    <Navigate
      push
      to={{
        pathname: location.pathname,
      }}
    />
  );
  return (
    <ErrorBoundary
       onReset={() => setRedirState(true)}
       FallbackComponent={ErrorFallbackDialog}
       page={"alertes"}
    >
      <GridContainer>
        <GridItem xs={12}>
          <Card>
            <CardBody>
              <AlertsTab alerts={<RTAlertes />} alertrules={<RTAlertRules />} events={<RTEvents />} systemalerts = {<RTSystemAlerts/>} selectedTab={selectedTab}/>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
      {redirecting}
    </ErrorBoundary>
  );
}
